import Vue from 'vue';

export async function index(params) {
  const response = await Vue.prototype.$http.get('/categories', {
    params
  });
  
  return response.data;
}

export async function changeLocalCategory(product_id, local_category) {
  const response = await Vue.prototype.$http.put(`categories/${product_id}/local_category`, { local_category });
  
  return response.data;
}